import {User} from '@/models'
const state = {
  loading: false,
  mode: '',
  snackbar: false,
  notice: '',
  alertBoxStatus: false,
  alertBoxText: '',
  s3Directory: 'https://s3.ap-south-1.amazonaws.com/prod-theseus-packages/project/tap/'
}

const getters = {}

const actions = {
  setLoading ({ commit }, status) {
    commit('setLoading', status)
  },
  // ----------------- Alert Boxes and Snackbar
  manageAlertBox ({ commit }, { status, text }) {
    commit('manageAlertBox', { status, text })
  },
  sendSuccessNotice ({ commit, dispatch }, notice) {
    commit('setNotice', {
      notice
    })
    commit('setSnackbar', {
      snackbar: true
    })
    commit('setMode', {
      mode: 'primary'
    })
    dispatch('closeNotice', 1500)
  },
  sendErrorNotice ({ commit, dispatch }, notice) {
    commit('setNotice', {
      notice
    })
    commit('setSnackbar', {
      snackbar: true
    })
    commit('setMode', {
      mode: 'error'
    })
    dispatch('closeNotice', 20000)
  },
  sendWarningNotice ({ commit, dispatch }, notice) {
    commit('setNotice', {
      notice
    })
    commit('setSnackbar', {
      snackbar: true
    })
    commit('setMode', {
      mode: 'secondary'
    })
    dispatch('closeNotice', 10000)
  },
  dealUnsuccessResponse ({ commit, dispatch }, response) {
    if (response.status === 'WARNING') {
      dispatch('sendWarningNotice', response.statusMessage)
    } else {
      dispatch('sendErrorNotice', 'Seems there is a problem, please try after some time.')
    }
  },
  closeNotice ({ commit }, timeout) {
    setTimeout(() => {
      commit('setSnackbar', {
        snackbar: false
      })
      commit('setNotice', {
        notice: ''
      })
      commit('setMode', {
        mode: ''
      })
    }, timeout)
  }
}

const mutations = {
  // ----------------- Authentication and Authorization
  logout (state, token) {
    state.loading = false
    state.alertBoxStatus = false
    state.alertBoxText = ''
    state.user = new User()
    state.access = 'logout'
    state.afterOk = () => {}
    state.token = ''
  },
  manageAlertBox (state, { status, text, afterOk }) {
    state.alertBoxText = text
    state.alertBoxStatus = status
    state.afterOk = afterOk
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setNotice (state, { notice }) {
    state.notice = notice
  },
  setSnackbar (state, { snackbar }) {
    state.snackbar = snackbar
  },
  setMode (state, { mode }) {
    state.mode = mode
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js